import React, { useState } from "react";
import "./TwoWheelerPUC.css";

export default function TwoWheelerPUC() {

  const [rcNumber, setRcNumber] = useState("");
  const [rcImage, setRcImage] = useState(null);
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("PUC 2 Wheeler Request Submitted ");
  };

  return (
    <div className="tw-wrapper">

      <h2 className="tw-title">PUC Apply - 2 Wheeler (₹170)</h2>
      <div className="tw-divider"></div>

      {/* FORM */}
      <div className="tw-card">
        <form onSubmit={handleSubmit}>

          <label>RC Number</label>
          <input
            type="text"
            placeholder="Enter RC Number"
            value={rcNumber}
            onChange={(e) => setRcNumber(e.target.value)}
            required
          />

          <label>Upload RC Image</label>
          <input
            type="file"
            onChange={(e) => setRcImage(e.target.files[0])}
            required
          />

          <label>Vehicle Front Photo</label>
          <input
            type="file"
            onChange={(e) => setFrontImage(e.target.files[0])}
            required
          />

          <label>Vehicle Back Photo</label>
          <input
            type="file"
            onChange={(e) => setBackImage(e.target.files[0])}
            required
          />

          <button className="tw-apply-btn" type="submit">
            Apply Now
          </button>

          <p className="tw-info">
            After apply please wait 1 to 3 hours. Admin will approve and upload your PUC.
          </p>

        </form>
      </div>

      {/* TABLE */}
      <h3>Your PUC Requests</h3>

      <table className="tw-table">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>RC Number</th>
            <th>Status</th>
            <th>Remark</th>
            <th>Download</th>
          </tr>
        </thead>

        <tbody>
          {/* Blank By Default - Data backend se aayega */}
        </tbody>
      </table>

    </div>
  );
}
